import "@fontsource/roboto";

import { Route, BrowserRouter as Router, Routes } from "react-router-dom";

import "./assets/styles/app.css";
import EventListener from "./components/global/EventListener";
import Footer from "./components/global/Footer";
import Header from "./components/global/Header";
import LoadingIndicator from "./components/global/LoadingIndicator";
import Navigation from "./components/global/Navigation";
import RoleBasedRender, { UnauthorizedPage } from "./components/shared/RoleBasedRender";
import { RoutesConfig } from "./configs/Routes";

const renderRoutes = () => (
  <Routes>
    {RoutesConfig.map(({ path, auth, component }) => (
      <Route
        key={path}
        path={path}
        element={
          auth ? (
            <RoleBasedRender
              requiredRoles={auth.requiredRoles}
              fallback={auth.unauthorizedFallbackOverride || UnauthorizedPage}
            >
              {component}
            </RoleBasedRender>
          ) : (
            component
          )
        }
      />
    ))}
  </Routes>
);

function App() {
  return (
    <Router>
      <EventListener />
      <Header />
      <Navigation />
      <LoadingIndicator />
      {renderRoutes()}
      <Footer />
    </Router>
  );
}

export default App;
